import React, { useRef, useEffect } from "react";

const StatsCommentTextArea = ({
  questionId,
  value,
  onChange,
  disabled,
  registerRef,
}) => {
  const textareaRef = useRef(null);

  // Register the ref with parent if needed
  useEffect(() => {
    if (registerRef) registerRef(questionId, textareaRef);
  }, [questionId]);

  // Adjust height on content change
  useEffect(() => {
    adjustHeight();
  }, [value]);

  const adjustHeight = () => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  };

  return (
    <textarea
      ref={textareaRef}
      rows={1}
      style={{
        resize: "none"
      }}
      className="form-control no-resize"
      value={value}
      onChange={(e) => {
        onChange(questionId, e);
        adjustHeight(); // immediate feedback
      }}
      disabled={disabled}
    />
  );
};

export default StatsCommentTextArea;


